(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('SpecialtySearch', SpecialtySearch);

    SpecialtySearch.$inject = ['$resource'];

    function SpecialtySearch($resource) {
        var resourceUrl =  'api/_search/specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
